import { CodeTypeModel } from "./code-type.model";
import { LookUpModel } from "./look-up.model";
import { CommonMethods } from "@services/common.method";

export class EquipmentHistoryModel {
  public CategoryName: string;
  public ManufacturerName: string;
}
export class EquipmentModel extends EquipmentHistoryModel {
  //public UnitOfMeasurement: UnitOfMeasurment;
  public ApproximateYear: string;
  public EquipmentCategory: LookUpModel;
  public CategoryID: string;
  public EquipmentWarranties: WarrantyModel[];
  public ID: string;
  public InstalledBy: CodeTypeModel;
  public InstallDate: string;
  public InstalledByID: string;
  public IsActive: boolean;
  public IsDeleted: boolean;
  public JobSiteID: string;
  public Location: string;
  public EquipmentManufacturer: LookUpModel;
  public ManufacturerID: string;
  public ModelNumber: string;
  public ModifyDate: Date;
  public Note: string;
  public PriceBookID: string;
  public SerialNumber: string;
  public Size: string;
  public constructor() {
    super();
    this.ModelNumber = "";
    this.ID = "";
    this.JobSiteID = "";
    this.PriceBookID = null;
    this.IsDeleted = false;
    this.EquipmentManufacturer = new LookUpModel();
    this.ManufacturerID = "";
    this.CategoryID = "";
    this.EquipmentCategory = new LookUpModel();
    this.SerialNumber = "";
    this.InstalledBy = new CodeTypeModel();
    // this.UnitOfMeasurement = new UnitOfMeasurment();
    this.Location = "";
    this.InstallDate = (new Date()).toDateString();
    this.EquipmentWarranties = [];
    this.ApproximateYear = "";
    this.Note = "";
    this.CategoryName = "";
    this.ManufacturerName = "";
  }
}
export class WarrantyModel extends LookUpModel{
  CreateDate: string;
  DurationType: CodeTypeModel;
  DurationTypeID: string;
  DurationValue: number;
  ExpirationDate: string;
  InstallDate: string;
  IsDirty: boolean;
  IsValidInstallDate: DateValidity;
  LifetimeWarranty: boolean;
  ModifyDate: string;
  UsedInID: string;
  WarrantyDescription: string;
  WarrantyName: string;
  WarrantyTypeID: string;
  equipmentId: string;
  constructor() {
    super();
    this.DurationType = new CodeTypeModel();
  }
}
export enum DateValidity {
  Valid = 0,
  Invalid = 1,
  Valid_Before1900 = 2
}
export class EquipmentWarrantyTypesFromCompany {
  CompanyID: string;
  CreateDate: string;
  CreatedByUserID: string;
  DeleteDate: string;
  Description: string;
  DurationTypeID: string;
  DurationValue: number;
  EquipmentWarranties: any[];
  ID: string;
  IsActive: boolean;
  LifetimeWarranty: boolean;
  ModifiedByUserID: string;
  ModifyDate: string;
  Name: string;
  UsedInID: string;
  DurationType: CodeTypeModel;
  constructor() {
    this.DurationType = new CodeTypeModel();
  }
}
export class EquipmentManufacturers {
  CompanyID: string;
  CreateDate: string;
  CreatedByUserID: string;
  DeleteDate: string;
  Description: string;
  ID: string;
  Isdeleted: false
  ModifiedByUserID: string;
  ModifyDate: string;
  Name: string;
}
export class EquipmentCategories {
  CompanyID: string;
  CreateDate: string;
  CreatedByUserID: string;
  DeleteDate: string;
  Description: string;
  ID: string;
  Isdeleted: boolean;
  ModifiedByUserID: string;
  ModifyDate: string;
  Name: string;
}
export class WarrantyTypeModel {
  Name: string;
  Description: string;
  DurationType: CodeTypeModel;
  DurationValue: number;
  IsLifeTime: boolean;
  UsedIn: any;
  IsActive: boolean;
  ID: string;
}
export class MultiSelectModel extends EquipmentModel {
  public IsSelected: boolean;
  constructor() {
    super();
    this.IsSelected = false;
  }
}